<template>
	<div>
		<template v-if="showSelection">
			<v-chip v-for="(it, i) in selected" :key="i">
				{{ it.nickname }}({{ u.id }})
				<v-btn @click="unselect(i)" text color="error"><v-icon>$delete</v-icon></v-btn>
			</v-chip>
		</template>
		<v-btn @click="showEditor = true">选择</v-btn>
		<v-dialog v-model="showEditor" max-width="600px">
			<v-card>
				<list ref="list" show-select :single-select="false" :headers="headers">
					<template v-slot:batchActions="{ selected }">
					</template>
					<template v-slot:actions="{ item }">
						<v-btn @click="select(item)">选择</v-btn>
					</template>
				</list>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import List from './List.vue'
export default {
	props: {
		multiple: { type: Boolean, default: false },
		showSelection: { type: Boolean, default: true }
	},
	components: { List },
	data() {
		return {
			selected: [],
			showEditor: false,
			headers: [
				{ text: '#', value: 'id' },
				{ text: '名称', align: 'left', sortable: true, value: 'name' },
				{ text: '状态', value: 'status' },
				{ text: '', align: 'left', sortable: false, value: 'action', },
			],
		}
	},
	mounted() {
	},
	computed: {
		selectedIds() {
			return this.selected.map(e => e.id)
		}
	},
	watch: {
	},
	methods: {
		select(item) {
			let idx = this.selected.findIndex(e => e.id === item.id)
			if (idx >= 0) {
				alert(`${item.name}(${item.id})已选择`)
			} else {
				if (this.multiple === false) {
					this.selected = []
				}
				this.selected.push(item)
				this.$emit('selected', this.selectedIds, this.selected)
			}
			this.showEditor = false
		},
		unselect(idx) {
			this.selected.splice(idx, 1)
			this.$emit('selected', this.selectedIds, this.selected)
		}
	}
};
</script>

<style scoped></style>
